import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchPlaceholder: {
		id: 'directories.boards-v2.main.content.filter.search-placeholder',
		defaultMessage: 'Search boards',
		description: 'Placeholder to be displayed for a keyword search feild on boards directory',
	},
	projectPlaceholder: {
		id: 'directories.boards-v2.main.content.filter.project-placeholder',
		defaultMessage: 'Select project',
		description: 'Placeholder to be displayed for a project picker on boards directory',
	},
	projectLabel: {
		id: 'directories.boards-v2.main.content.filter.project-label',
		defaultMessage: 'Project',
		description: 'Label to be displayed for a project picker on boards directory',
	},
});
